/**
 * A chapter's ADB PageID from the `$pageId` path segment: digits only. Anything
 * else is NaN, which loaders turn into a 404. (Not 0: chapters without a
 * Facebook page have `ID: 0`, so a junk id would show one of them.)
 */
export function parsePageId(raw: string): number {
  return /^\d+$/.test(raw) ? Number(raw) : Number.NaN
}
